import React, { useState } from "react";
import { 
  Settings, 
  // FileText,
  Globe
} from "lucide-react";
import SEOSettings from "./SEOSettings";
// import PageManager from "./PageManager";

export default function SEOIndex() {
  // const [activeTab, setActiveTab] = useState("page-seo");

  // Tabs are commented out — render Individual Page SEO directly
  // const tabs = [
  //   {
  //     id: "page-seo",
  //     name: "Individual Page SEO",
  //     icon: <Settings size={20} />,
  //     component: <SEOSettings />
  //   },
  //   // {
  //   //   id: "page-manager",
  //   //   name: "Page Management",
  //   //   icon: <FileText size={20} />,
  //   //   component: <PageManager />
  //   // }
  // ];

  return (
    <div className="seo_module">
      <div className="container-fluid">
        {/* Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="d-flex align-items-center">
              <Globe size={32} className="text-primary me-3" />
              <div>
                <h2 className="mb-1">SEO Management</h2>
                <p className="text-muted mb-0">
                  Optimize your website's search engine performance
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Tabs removed - only Individual Page SEO is shown */}

        {/* Render the Individual Page SEO component directly */}
        <div className="row">
          <div className="col-12">
            <SEOSettings />
          </div>
        </div>
      </div>
    </div>
  );
}
